import React from 'react'
import VirtualCardDetail from 'src/app/VirtualCardDetail/VirtualCardDetail'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import VirtualCardsNeedsApprovalAppRoute from 'src/navigation/appRoutes/virtualCards/virtualCardsNeedsApproval.appRoute'
import VirtualCardsRequestsAppRoute from 'src/navigation/appRoutes/virtualCards/virtualCardsRequests.appRoute'
import VirtualCardsYourCardsAppRoute from 'src/navigation/appRoutes/virtualCards/virtualCardsYourCards.appRoute'
import YourCardsActiveAppRoute from 'src/navigation/appRoutes/yourCards/yourCardsActive.appRoute'
import YourCardsInactiveAppRoute from 'src/navigation/appRoutes/yourCards/yourCardsInactive.appRoute'
import { virtualCardDetailRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'
import VirtualCardsAllCardsAppRoute from './virtualCards/virtualCardsAllCards.appRoute'

const VirtualCardDetailAppRoute: AppRoute = {
  id: AppLocation.VirtualCardDetail,
  routeProps: virtualCardDetailRouteProps,
  component: <VirtualCardDetail />,
  subRoutes: [],
  exceptions: [
    YourCardsActiveAppRoute,
    YourCardsInactiveAppRoute,
    VirtualCardsAllCardsAppRoute,
    VirtualCardsYourCardsAppRoute,
    VirtualCardsRequestsAppRoute,
    VirtualCardsNeedsApprovalAppRoute,
  ],
  meta: { contentType: SidenavContentType.Main },
}

export default VirtualCardDetailAppRoute
